// extracted by mini-css-extract-plugin
module.exports = {"root":"a10a3f92e9--root--xBb_9","cards":"a10a3f92e9--cards--J3PIo","card":"a10a3f92e9--card--HrwSH"};